const initialState = () => {
    return {
        /**
         * @description
         */
        menues: null,
        titleTopBar: 'default',

    }
}

export default initialState
